var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckbadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/checkbadge"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4067 14.8182C20.3704 14.1395 21 13.0183 21 11.75C21 10.4819 20.3706 9.36087 19.4071 8.68218C19.6087 7.52081 19.2611 6.28274 18.3643 5.3859C17.4674 4.48906 16.2294 4.14145 15.068 4.34307C14.3893 3.3795 13.2682 2.75 12 2.75C10.7318 2.75 9.61061 3.37955 8.93194 4.34319C7.77063 4.14166 6.53265 4.48929 5.63587 5.38607C4.7391 6.28284 4.39147 7.52079 4.59298 8.68208C3.62946 9.36077 3 10.4819 3 11.75C3 13.0181 3.62941 14.1391 4.59286 14.8178C4.39125 15.9792 4.73886 17.2173 5.6357 18.1141C6.53256 19.011 7.77066 19.3586 8.93204 19.157C9.61072 20.1205 10.7319 20.75 12 20.75C13.2682 20.75 14.3893 20.1205 15.068 19.1569C16.2292 19.3583 17.467 19.0106 18.3637 18.1139C19.2604 17.2172 19.6081 15.9794 19.4067 14.8182Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 12.5L11.25 14.75L15 9.5M21 11.75C21 13.0183 20.3704 14.1395 19.4067 14.8182C19.6081 15.9794 19.2604 17.2172 18.3637 18.1139C17.467 19.0106 16.2292 19.3583 15.068 19.1569C14.3893 20.1205 13.2682 20.75 12 20.75C10.7319 20.75 9.61072 20.1205 8.93204 19.157C7.77066 19.3586 6.53256 19.011 5.6357 18.1141C4.73886 17.2173 4.39125 15.9792 4.59286 14.8178C3.62941 14.1391 3 13.0181 3 11.75C3 10.4819 3.62946 9.36077 4.59298 8.68208C4.39147 7.52079 4.7391 6.28284 5.63587 5.38607C6.53265 4.48929 7.77063 4.14166 8.93194 4.34319C9.61061 3.37955 10.7318 2.75 12 2.75C13.2682 2.75 14.3893 3.3795 15.068 4.34307C16.2294 4.14145 17.4674 4.48906 18.3643 5.3859C19.2611 6.28274 19.6087 7.52081 19.4071 8.68218C20.3706 9.36087 21 10.4819 21 11.75Z",
    stroke: "#222222",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbadge);
export default __webpack_public_path__ + "static/media/checkbadge.e90039b79e6f91d673290c42ff852e3b.svg";
export { ForwardRef as ReactComponent };